<script>
    export default {
        props: {
            taskListTemplate: {
                type: Object,
                default: null,
            },
            taskListId: {
                type: Number,
                required: true,
            },
        },
        data() {
            return {
                createMoreOfThisType: false,
                task_template_parent_id: '',
            };
        },
        methods: {
            async create() {
                try {
                    const data = {
                        ...{
                            body: this.body,
                            type: this.type,
                        },
                        ... this.extraData,
                    };

                    await axios.post(route('api.tasks.store', this.taskListId), data);

                    this.$nextTick(() => {
                        this.body = '';
                    });

                    this.$emit('added', { keepCreateView: this.createMoreOfThisType });
                    flash_success('Tillagd!');
                } catch (e) {
                    flash_error('Kunde tyvärr inte skapa uppgiften, försök igen!');
                }
            },
        },
    };
</script>